module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR6.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP3"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 2",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP5"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 4",
      "src": "data/content-0003.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP6"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.3.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 5",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.3.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.0.0.box.433.753.775.106.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP7.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center",
      "font-weight": "bold",
      "margin-left": "0"
    },
    attrs: {
      "id": "para.6.0.0.box.433.753.775.106.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(" Remembering ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stasia, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mother")]), _vm._v("— "), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("her ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("vibrant ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("spirit, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("her ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("questing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mind ")]), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.0.0.box.178.733.491.44.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "107%",
      "text-indent": "0",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.8.0.0.box.178.733.491.44.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.3.2.0"
    }
  }), _vm._v("ILLUSTRATIONS")]), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.3.4.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.5.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.8.1.0.box.164.812.1333.765.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.6.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.7.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.7.0.0.1"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8.w.0.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.2.0.box.181.1669.169.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "107%",
      "text-indent": "0",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.8.2.0.box.181.1669.169.43.q.70"
    }
  }, [_vm._v("MAPS")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.8.3.0.box.181.1767.1254.152.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0006.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.0.0.box.307.721.1006.574.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP11.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_quote",
    attrs: {
      "id": "para.10.0.0.box.307.721.1006.393.q.60"
    }
  }, [_vm._v("Early in our industrial history this valley was the seat of the largest development of inland navigation in the United States; and perhaps you will pardon my mentioning that the first steamboat west of the Alleghanies [sic] was built by a Roosevelt, my great-grandfather's brother, in 1811, for the New Orleans trade, and in that year made the trip from Pittsburgh to New Orleans.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP11.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "text-align": "right",
      "margin-right": "2em"
    },
    attrs: {
      "id": "para.10.0.1.box.725.1154.587.141.q.60"
    }
  }, [_vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Theodore ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Roosevelt, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("speech ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("made ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.1.0"
    }
  }), _vm._v("  at ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Deep ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Waterway ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Convention ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("at ")]), _c('br'), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR10.w.0.0.0"
    }
  }), _vm._v("  Memphis, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tennessee, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("October ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("4, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("1907 ")]), _c('br')])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96932330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0007.vue
// module id = 54
// module chunks = 0